// extracted by mini-css-extract-plugin
module.exports = {"admin":"Admin_admin__3lfmz","container":"Admin_container__jlmyp"};